import GameCard from "components/molecules/GameCard";
import { makeLangUrl } from "helpers/makeLangUrl";
import { useCheckBalance } from "hooks/useCheckBalance";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import * as gameSelectors from "redux/game/selectors";
import { useRouterHistoryStore } from "stores/routerHistory";
import { useTournamentsStore } from "stores/tournaments";
import { GAME_MODE, GameType } from "types/Games";
import { GET_PARAMS } from "constants/popupConfig";
// import useTournamentsStore from "stores/";
import url from "url/index";
import { setGameUrl } from "redux/game/slice";

interface IGameCardContainer {
  game: GameType;
}

const GameCardContainer = (props: IGameCardContainer) => {
  const { game } = props;

  const category = useSelector(gameSelectors.category);
  const location = useLocation();
  const navigate = useNavigate();
  const checkBalance = useCheckBalance();
  const dispatch = useDispatch();
  const tournament = useTournamentsStore((state) => state.tournament);
  const setPreviousPage = useRouterHistoryStore(
    (state) => state.setPreviousPage,
  );

  const handleInitDemo = useCallback(() => {
    if (tournament) {
      const dataTournament = tournament
        ? `${tournament.id}:${tournament.name}`.replaceAll(" ", "").trim()
        : "";
      dispatch(setGameUrl(game.urlAlias));
      navigate({
        pathname: makeLangUrl(
          url.routes.casino.game({
            game: game.urlAlias,
          }),
        ),
        search: `?${createSearchParams({
          [GET_PARAMS.MODE]: GAME_MODE.DEMO,
          [GET_PARAMS.TOURNAMENT]: dataTournament,
        })}`,
      });
    } else {
      dispatch(setGameUrl(game.urlAlias));
      navigate({
        pathname: makeLangUrl(
          url.routes.casino.game({
            game: game.urlAlias,
          }),
        ),
        search: `?${createSearchParams({
          [GET_PARAMS.MODE]: GAME_MODE.DEMO,
        })}`,
      });
    }
    setPreviousPage(`${location.pathname}${location.search}`);
  }, [
    dispatch,
    game,
    tournament,
    navigate,
    setPreviousPage,
    location.pathname,
    location.search,
  ]);

  const handleInitByAlias = useCallback(() => {
    // eslint-disable-next-line no-console
    const isBalancePositive = checkBalance();
    if (isBalancePositive) {
      if (tournament) {
        const dataTournament = `${tournament.id}:${tournament.name}`
          .replaceAll(" ", "")
          .trim();
        dispatch(setGameUrl(game.urlAlias));
        navigate({
          pathname: makeLangUrl(
            url.routes.casino.game({
              game: game.urlAlias,
            }),
          ),
          search: `?${createSearchParams({
            [GET_PARAMS.TOURNAMENT]: dataTournament,
          })}`,
        });
      } else {
        dispatch(setGameUrl(game.urlAlias));
        navigate({
          pathname: makeLangUrl(
            url.routes.casino.game({
              game: game.urlAlias,
            }),
          ),
        });
      }
      setPreviousPage(`${location.pathname}${location.search}`);
    }
  }, [
    checkBalance,
    dispatch,
    game,
    tournament,
    navigate,
    setPreviousPage,
    location.pathname,
    location.search,
  ]);

  return (
    <GameCard
      category={category}
      game={game}
      onInitDemo={handleInitDemo}
      onInitByAlias={handleInitByAlias}
    />
  );
};

export default GameCardContainer;
